export const ROLES = {
  superAdmin: 'Super Admin',
  standardAdmin: 'Standard Admin',
};

export const USER_STATUS = {
  blocked: 'blocked',
  unblocked: 'unblocked',
};

//todo: to be removed across system after backend implementation
export const USERS_ROLES = {
  owner: 'owner',
  singleOwner: 'single owner',
  fleetOwner: 'fleet owner',
  driver: 'driver',
};
//todo: to be used across system after backend implementation
export const USERS_ROLES_TYPES = {
  primary: 'primary',
  singleOwner: 'single_owner',
  fleetOwner: 'fleet_owner',
  driver: 'driver',
};
export const POINTS_TYPES = {
  completeProfile: 'complete_profile',
  watchTutorial: 'watching_tutorial',
  completeTrip: 'trip_ended',
  addMaintenance: 'maintenance_created',
  joinTeam: 'join_team',
};

export const REWARDS_TYPES = {
  voucher: 'voucher',
  discount: 'discount',
  chargingCard: 'charging_card',
};

export const DISCOUNT_TYPES = {
  fixed: 'fixed',
  percentage: 'percentage',
};

export const REWARDS_STATUS = {
  active: 'active',
  inactive: 'inactive',
  expired: 'expired',
};

export const DRIVER_REWARDS_STATUS = {
  earned: 'earned',
  redemeed: 'redeemed',
  expired: 'redemption_expired',
};

export const TEAM_DRIVERS_STATUS = {
  member: 'member',
  formerMember: 'former_member',
};

export const TRIPS_STATUS = {
  ongoing: 'ongoing',
  ended: 'ended',
};

export const VERIFICATION_REQUEST_STATUS = {
  accepted: 'accepted',
  rejected: 'rejected',
};

export const DRIVER_VERIFICATION_REQUEST_STATUS = {
  pending: 'pending',
  rejected: 'rejected',
  accepted: 'accepted',
};

export const ACCEPTED_IMAGE_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/jpg',
];

export const ACCEPTED_EXCEL_FILES_TYPES = [
  'text/xlsx',
  'text/xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/json',
];

export const ACCEPTED_EXCEL_FILES_MAX_SIZE = 10 * 1024 * 1024; // 10 Mb

export const ACCEPTED_JSON_FILE_MAX_SIZE = 5 * 1024 * 1024; // 5 Mb

export const ACCEPTED_JSON_FILES_TYPES = [
  'application/json',
  'application/ld+json',
  'application/json-patch+json',
  'application/vnd.api+json',
];

export const ACCEPTED_IMAGE_FILE_MAX_SIZE = 1 * 1024 * 1024; //1 Mb
export const ACCEPTED_IMAGE_FILE_MAX_SIZE_FIVE_MB = 5 * 1024 * 1024; //5 Mb

export const OFFER_BANNER_ASPECT_RATIO = 2 / 1;

export const PHONE_NUMBER_REGEX = /^(01[0-2]|015|10|11|12|15)\d{8}$/;
export const ONLY_POSITIVE_NUMBERS_WITH_ZERO = /^[0-9][0-9]*$/;
export const ONLY_POSITIVE_NUMBERS_GREATER_THAN_ZERO = /^[1-9][0-9]*$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_-])(?=.{10,})/;
export const TEXT_ONLY_REGEX =
  /^[a-zA-Z\u0600-\u06FF\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]+$/;
export const ARABIC_TEXT_REGEX =
  /^[\u0600-\u06FF\s0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]+$/;
export const ENGLISH_TEXT_REGEX =
  /^[\p{Script=Latin}\p{N}\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]+$/u;
export const ARABIC_TEXT_REGEX_WITHOUT_NUMBERS =
  /^[\u0600-\u06FF\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]+$/;
export const ENGLISH_TEXT_REGEX_WITHOUT_NUMBERS =
  /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]+$/;

// Ports of the BE's TEXT_INPUT_EN / TEXT_INPUT_AR validators: instead of an
// allowlist, only the opposite-language characters are rejected, so every
// other script, punctuation mark, and symbol (incl. emoji) is allowed. Used
// where product wants that BE-matching behavior (e.g. Challenges copy
// fields) without changing the stricter shared regexes used elsewhere (e.g.
// Offers).
export const ENGLISH_TEXT_WITH_EMOJI_REGEX =
  /^(?=.*\S)(?:(?![\p{Script=Arabic}،؛؟])[\s\S])+$/u;
export const ARABIC_TEXT_WITH_EMOJI_REGEX =
  /^(?=.*\S)(?:(?![a-zA-Z])[\s\S])+$/u;

export const URL_REGEX = /^(https?:\/\/)([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/;

export const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;

export const NATIONAL_ID_REGEX = /^[23]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{7}$/;

export const OFFER_STATUS = {
  pending: 'pending',
  started: 'started',
  expired: 'expired',
};

export const CARD_STATUS_COLORS = {
  pending: '#f0ad4e',
  started: '#5cb85c',
  expired: '#d9534f',
};

export const ANIMATION_STATUS_COLOR = {
  pending: '#f0ad4e',
  started: '#5cb85c',
  expired: '#d9534f',
};

export const OFFER_PUBLISHED_STATUS = {
  published: 'published',
  unpublished: 'unpublished',
};

export const OFFER_PUBLISHED_STATUS_COLORS = {
  published: '#5cb85c',
  unpublished: '#d9534f',
};

export const CHALLENGE_PUBLISHED_STATUS = {
  published: 'published',
  unpublished: 'unpublished',
};

export const CHALLENGE_PUBLISHED_STATUS_COLORS = {
  published: '#5cb85c',
  unpublished: '#d9534f',
};

export const CALL_TO_ACTIONS_TYPES = {
  sdkVoucher: 'sdk_voucher',
  urlField: 'url',
  promocodesOffer: 'promocodes_offer',
};

export const ANIMATION_STATUS = {
  pending: 'pending',
  started: 'started',
  expired: 'expired',
};

export const ANIMATION_ACTIVE_STATUS = {
  active: 'active',
  inactive: 'inactive',
};

export const ANIMATION_ACTIVE_STATUS_COLORS = {
  active: '#5cb85c',
  inactive: '#d9534f',
};

export const NATIONAL_ID_STATUS = {
  approved: "verified",
  pending: "pending",
  rejected: "failed",
  notSubmitted: "not_started",
};

export const NATIONAL_ID_STATUS_COLORS = {
  approved: "#5cb85c",
  pending: "#f0ad4e",
  rejected: "#d9534f",
  notSubmitted: "#9c9c9c",
};

export const USER_SEGMENTS = {
  uncategorizedBasic: "uncategorized_basic",
  pvBasic: "pv_basic",
  pvSilver: "pv_silver",
  pvGold: "pv_gold",
  pvPlatinum: "pv_platinum",
  cvBasic: "cv_basic",
  cvSilver: "cv_silver",
  cvGold: "cv_gold",
  cvPlatinum: "cv_platinum",
};

// Matches the tier colors used on the member loyalty cards (Classic/blue, Silver/grey, Gold/yellow, Platinum/bronze-on-dark)
export const USER_SEGMENT_TIER_COLORS = {
  basic: "#4A90E2",
  silver: "#9AA5B1",
  gold: "#E3B341",
  platinum: "#C08552",
};

export const CHALLENGE_STATUS = {
  pending: 'pending',
  started: 'started',
  ended: 'ended',
  draft: 'draft',
};

export const CHALLENGE_TYPE = {
  promo: 'promo',
  quick: 'quick',
};

export const CHALLENGE_USER_STATUS = {
  pedning: 'pending',
  nonWinner: 'non_winner',
  winnerCandidate: 'winner_candidate',
  winner: 'winner',
  adminDeselected: 'admin_deselected',
};

export const CHALLENGE_WINNER_STATUS = {
  winner: 'winner',
  nonWinner: 'non_winner',
  notQualified: 'not_qualified',
};

export const CHALLENGE_REWARD_STATUS = {
  earned: 'earned',
  selected: 'selected',
  redeeming: 'redeeming',
  redeemed: 'redeemed',
  selectionExpired: 'selection_expired',
  redemptionExpired: 'redemption_expired',
};

export const CHALLENGE_REWARD_TYPE = {
  airRecharge: 'air_recharge',
};

// BE `notification_type` per challenge notification slot on the form.
export const CHALLENGE_NOTIFICATION_TYPE = {
  publishing: 'start_quick_challenge',
  reminder: 'mid_quick_challenge',
  lastDay: 'last_day_quick_challenge',
  winners: 'winner',
  nonWinners: 'non_winner',
};

export const CHALLENGE_STATUS_COLORS = {
  pending: '#f0ad4e',
  started: '#5cb85c',
  ended: '#d9534f',
  draft: '#006BB6',
};

export const CHALLENGE_TYPE_COLORS = {
  quick: '#00897B',
  promo: '#7B1FA2',
};

export const CHALLENGE_TARGET_PERSONAS = {
  fo: 'fo',
  so: 'so',
  driver: 'driver',
};

export const RED_FLAG_SOURCE = {
  ai: 'ai',
  backendRule: 'backend_rule',
  manual: 'manual',
};

export const SIGNAL_VALUE_TYPE = {
  numeric: 'numeric',
  boolean: 'boolean',
};

// Map a form persona code to the BE `user_type` used to filter challenge
export const PERSONA_USER_TYPE = {
  [CHALLENGE_TARGET_PERSONAS.fo]: USERS_ROLES_TYPES.fleetOwner,
  [CHALLENGE_TARGET_PERSONAS.so]: USERS_ROLES_TYPES.singleOwner,
  [CHALLENGE_TARGET_PERSONAS.driver]: USERS_ROLES_TYPES.driver,
};

// Reverse of PERSONA_USER_TYPE — maps a BE `user_type` back to a form persona
// code (used when reading a challenge's sub-tasks from the show endpoint).
export const USER_TYPE_PERSONA = {
  [USERS_ROLES_TYPES.fleetOwner]: CHALLENGE_TARGET_PERSONAS.fo,
  [USERS_ROLES_TYPES.singleOwner]: CHALLENGE_TARGET_PERSONAS.so,
  [USERS_ROLES_TYPES.driver]: CHALLENGE_TARGET_PERSONAS.driver,
};

